
document.addEventListener('DOMContentLoaded',()=>{
    let ad = document.querySelector('.ad-html-container .article-ad');

    if(ad){
        let html = ad.outerHTML;
        let id = ad.parentNode.getAttribute('data-ad-elem');
        let container = document.querySelector(`[ad-id="${id}"]`);

        if(container){
            container.insertAdjacentHTML('afterend',html);
        }
    }
})